import append from "ramda/es/append";
import prepend from "ramda/es/prepend";
export default {
    next (state, action) {
        const config = state.config;
        const toast = {
            id: crypto.randomUUID(),
            position: config.position,
            ...action.payload
        };
        if (config.newestOnTop) {
            state = {
                ...state,
                toasts: prepend(toast, state.toasts)
            };
        } else {
            state = {
                ...state,
                toasts: append(toast, state.toasts)
            };
        }
        return state;
    }
};
